<template>
    <div>
        <v-divider></v-divider>
        <v-list subheader dense>
            <v-subheader>
                Lobby Guests
            </v-subheader>

            <v-list-item v-for="guest in lobbyGuests" :key="guest.presence_ref">
                <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-account-circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>{{ guest.guest_name != '' ? `${guest.guest_name}` : `Anonymous`}}</v-list-item-title>
                    <!-- <v-list-item-subtitle v-text="peer.roleName.toUpperCase()"></v-list-item-subtitle> -->
                </v-list-item-content>

                <v-list-item-icon class="pt-2"> 
                    <v-btn x-small @click="admit(guest)" color="primary">Admit</v-btn>
                </v-list-item-icon>
                
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { useMeetingStore } from '../stores/meeting'
import { useAppStore } from '../stores/app'
// import MeetingParticipantMenu from './MeetingParticipantMenu.vue'

export default {
    name: 'MeetingLobbyGuests',
    // props: ['peer', 'local_peer'],
    // components: { MeetingParticipantMenu },
    data: function() {
        return {
            meeting: null,
            app: null,
        }
    },
    created: function() {
        this.meeting = useMeetingStore()
        this.app = useAppStore()
    },
    computed: {
        lobbyGuests() {
            // console.log('lobbyGuests', this.meeting.lobby_presence_channel.presenceState().lobby.filter(guest => guest.action != "admit")            
            // console.log("lobby channel.presenceState", Object.keys(this.meeting.lobby_presence_channel))
            // Object.keys(this.meeting.lobby_presence_channel).forEach(channel => {
            //     console.log("test lobbyGuests:", this.meeting.lobby_presence_channel[channel].presenceState())
            // })
            let guests = []
            Object.keys(this.meeting.lobby_presence_channel).forEach(channel => {
                let lobby = this.meeting.lobby_presence_channel[channel].presenceState()
                Object.keys(lobby).forEach(guest => {
                    console.log("guest", lobby[guest])
                    if(lobby[guest][0].guest_name) {
                        lobby[guest][0].channel = channel
                        guests.push(lobby[guest][0])
                    }
                })
                // if(Array.isArray(lobby)) {
                //     console.log('loop through the lobby')
                //     lobby.forEach(guest => {
                //         console.log("guest_name" , guest.guest_name)
                //         guest.channel = channel
                //         guests.push(guest)
                //     })
                //     // console.log('lobbyGuests', channel, guests)
                // }
            })
            return guests
        },
    },
    methods: {
        
        async admit(guest) {
            console.log("admit", guest)
            const lobbyPresenceTrackStatus = await this.meeting.lobby_presence_channel[guest.channel].track({
                action: "admit",
                url: window.location.origin + window.location.pathname + '#/',
                room_id: this.app.room.ID,
                guest
            })
        }
    }
    // watch: {
    //    'meeting.lobbies': {
    //         handler() {
    //             console.log('lobbies updated!', this.meeting.lobbies)
    //         },
    //         deep: true
    //     },
    // }
}
</script>
